export default __webpack_public_path__ + "static/media/36I-117136_-44086_0.1295c918.jpg";